import React from 'react';
import intl from 'react-intl-universal';
import { Button } from 'semantic-ui-react';
import { User } from '../../../../typings/types';
import { formatUnixDateAtTimeForDisplay } from '../../../../utils/date-time-utils';
import * as styles from './DevicesTab.scss';
import _memoize from 'lodash/memoize';
import { Mutation } from 'react-apollo';
import removeDeviceFromUserMutation from 'queries/users/removeDeviceFromUserMutation.gql';
import _get from 'lodash/get';
import { ICON_DESCRIPTION } from 'constants/roomSystemConstants';

interface Props {
  data: User;
  closeModal: () => void;
}

class DevicesTab extends React.PureComponent<Props> {
  getDeviceData = _memoize((data) => {
    const pairedDevice = _get(data, 'pairedDevice', null);
    if (!pairedDevice) {
      return <p>{intl.get('userDeviceNoDevicesAssociated')}</p>;
    }
    return [
      (
        <dl key="deviceData">
          <dt>{intl.get('userDeviceLabelDevice')}:</dt>
          <dd>{ICON_DESCRIPTION[pairedDevice.platform.trim()]}</dd>
          <dt>{intl.get('userDeviceLabelActivated')}:</dt>
          <dd>{formatUnixDateAtTimeForDisplay(parseInt(pairedDevice.pairingTimeMillis, 10))}</dd>
          <dt>{intl.get('userDeviceLabelVersion')}:</dt>
          <dd>{pairedDevice.firmware}</dd>
          <dt>{intl.get('userDeviceLabelSerial')}:</dt>
          <dd>{pairedDevice.serialNumber}</dd>
        </dl>
      ),
      (
        <Mutation mutation={removeDeviceFromUserMutation} key="disassociateDevice">
          {(removePairedDeviceUser) => (
            <a
              onClick={async () => {
                try {
                  await removePairedDeviceUser({
                    variables: {
                      UUID: data.UUID
                    }
                  });
                  this.props.closeModal();
                } catch (e) {
                  // not sure yet...
                }
              }}
            >
              {intl.get('disassociateDevice')}
            </a>
          )}
        </Mutation>
      )
    ];
  });

  render(): React.ReactNode {
    const { closeModal, data } = this.props;
    if (data) {
      data[`uuid`] = _get(data, 'UUID');
    }

    return (
      <div className={styles.container}>
        {this.getDeviceData(data)}
        <footer>
          <Button
            className={styles.button}
            id="btnCancel"
            name="btnCloseModal"
            onClick={closeModal}
            role="button"
            type="button"
          >
            {intl.get('modalCancel')}
          </Button>
        </footer>
      </div>
    );
  }
}

export default DevicesTab;
